import { useEffect } from "react";
import { useTheme } from "next-themes";
import { useEmpresa } from "@/hooks/useEmpresa";
import { applyEmpresaTheme, clearEmpresaTheme } from "@/lib/themeTokens";

export default function EmpresaThemeProvider({ children }) {
  const { empresa } = useEmpresa();
  const { resolvedTheme } = useTheme();
  const colores = empresa?.plantilla_colores?.colores;

  useEffect(() => {
    if (!colores) {
      clearEmpresaTheme(null);
      return undefined;
    }
    const mode = resolvedTheme === "dark" ? "dark" : "light";
    applyEmpresaTheme(colores, mode);
    return () => clearEmpresaTheme(colores);
  }, [colores, resolvedTheme]);

  return children;
}
